import type { Widget } from '@/lib/manifest/types';

/**
 * Read the `widgets[]` off a connected agent's full manifest. The manifest is
 * resolved from the DDC registry by vault-api at connect time and rides on
 * `AgentConnection.manifest` (typed `unknown`) — NOT on the card-only
 * marketplace endpoint, which never carries widgets. Widgets shipped via
 * `cef push` have no `embedUrl`; they carry `dag`/`entry` (see resolveWidgetUrl),
 * so the only field required here is a string `id`. Extra fields (kind, config,
 * cubbyAlias, …) pass through verbatim via the Widget index signature.
 */
export function manifestWidgets(manifest: unknown): Widget[] {
  if (!manifest || typeof manifest !== 'object') return [];
  const widgets = (manifest as { widgets?: unknown }).widgets;
  if (!Array.isArray(widgets)) return [];
  return widgets.filter(
    (w): w is Widget => !!w && typeof w === 'object' && typeof (w as { id?: unknown }).id === 'string',
  );
}
